import { LANGUAGE_ENGLISH, LANGUAGE_ENGLISH_MURABAHA } from '../constants';

const IDS = { PAGE_TITLE: 'helmetMessages.pageTitle' };

const enMessages = { [IDS.PAGE_TITLE]: 'Your Loan Servicing Center' };

const enMurabahaMessages = {
  ...enMessages,
  [IDS.PAGE_TITLE]: 'Your Account Servicing Center',
};

export const INTL_IDS = IDS;

export default {
  [LANGUAGE_ENGLISH]: enMessages,
  [LANGUAGE_ENGLISH_MURABAHA]: enMurabahaMessages,
};
